import RunStateBadge from "components/Run/elements/StateBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { StackPullRequestsTableRunCellProps } from "../types";

const StackPullRequestsTableRunStatusCell = ({
  item: { run },
  ...cellProps
}: StackPullRequestsTableRunCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <RunStateBadge state={run.state} />
    </TableSimpleCell>
  );
};

export default StackPullRequestsTableRunStatusCell;
